<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4>Attach Enclosed Area Document</h4>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content>
    <br />
    <div class="flex flex-col w-full">
      <div class="flex flex-col w-full">
        <div class="form-group">
          <label>Complaint ID: </label>
          {{correspondence.complaintId}}
        </div>
        <div class="form-group">
          <label>Title: </label>
          {{correspondence.title}}
        </div>
        <div class="flex flex-row w-full">
          Add File: <span style="color:red;">* Required</span>
        </div>
        <div>
          <input type="file" class="file-input" (change)="uploadFile($event)" hidden="true" #csvFileUpload1>
          <button mat-raised-button class="m-8" color="accent" (click)="csvFileUpload1.click()">
            <mat-icon>attach_file</mat-icon>Add File
          </button>
          <div>{{fileName}}</div>
        </div>
        <span style="color:orange;">
          <br />
          <p>File size limit: 4MB</p>
        </span>
      </div>
      <hr style="border: 1px solid gray;">
      <br />
      <div class="flex flex-row w-full">
        <div style="padding-right: 20px;">
          <button mat-raised-button (click)="return()" style="padding-right: 20px;">
            Return
          </button>
        </div>
        <div>
          <button mat-raised-button (click)="addFile()" style="background: #7ABDF3;">
            <mat-icon>save</mat-icon> Save
          </button>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

